<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Administradores</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Administradores',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-btn  v-if="$check(['admins.create'])" id="btnNew" type="button" color="primary" elevation="0"
                            to="/administradores/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name"
                                        hide-details outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field dense id="emailFilter" label="Email" v-model="dataList.filter.email"
                                        hide-details outlined></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Aplicar filtros</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:items-per-page="pageSizeChanged" @update:page="pageChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum local encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.name`]="{ item }">
                                <v-avatar :size="30">
                                    <img :src="'https://ui-avatars.com/api/?name=' + item.name" />
                                </v-avatar>
                                <span class="ml-4 list-item-title">{{ item.name }}</span><br />
                            </template>

                            <template v-slot:[`item.role`]="{ item }">
                                <span>{{ item.role ? item.role.name : 'N/A' }}</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['admins.update'])" v-on="on" @click="editItem(item)" size="large">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar administrador</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['admins.delete'])" v-on="on"
                                                @click="deleteItem(item)" size="large">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Remover administrador</span>
                                    </v-tooltip>
                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- MODAL DE EXCLUSÃO ADMIN -->
        <v-dialog v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 error--text">mdi-alert-circle-outline</v-icon>
                    Aviso
                </v-card-title>
                <v-card-text class="pt-4 black--text">
                    Tem certeza que deseja excluir o administrador
                    <strong v-if="adminToDelete">{{ adminToDelete.name }}</strong>?
                    Esta ação não pode ser desfeita.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="deleteDialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="red darken-1" text @click="confirmDelete()">
                        Excluir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "AdminList",

    data: () => ({
        dataset: {
            data: {}
        },
        dataList: {
            filter: {},
            headers: [
                { text: "Nome", value: "name" },
                { text: "Email", value: "email" },
                { text: "Papel", value: "role" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['id'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },

        deleteDialog: false,
        adminToDelete: null,
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        async load() {
            this.dataList.loading = true;

            try {
                const params = {
                    page: this.dataList.options.page,
                    limit: this.dataList.options.size,
                    search: { ...this.dataList.filter }
                };

                const result = await axios.get('api/v2/admins', { params });

                console.log("Dados: ", result);

                this.dataList.data = result.data.data;
                this.dataList.count = result.data.total;

            } catch (error) {
                console.log('error ', error);
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        editItem(item) {
            this.$router.push(`administradores/${item.id}`);
        },

        deleteItem(item) {
            this.adminToDelete = item;
            this.deleteDialog = true;
        },

        async confirmDelete() {
            this.deleteDialog = false;
            this.dataList.loading = true;

            try {
                await axios.delete(`api/v2/admins/${this.adminToDelete.id}`);

                this.dialog.notify.success('Administrador removido com sucesso!', { position: 'top-right', timeout: 3000 })

                this.load();

            } catch (error) {
                console.error('Erro ao remover administrador:', error);
                this.$dialog.notify.error(`Erro ao remover administrador: ${this.$codes(error)}`, { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
                this.adminToDelete = null;
            }

        },

    },
};
</script>